import DraftChargeProcessesList from "./DraftChargeProcessesList";

export default {
    list: DraftChargeProcessesList
};
